import {
    FaArchive,
    FaBookOpen,
    FaBuilding,
    FaCalendarAlt,
    FaChalkboardTeacher, FaChartBar, FaCheckSquare,
    FaCity, FaClipboard,
    FaClipboardCheck,
    FaCogs,
    FaComments,
    FaExclamationCircle,
    FaExclamationTriangle,
    FaEye,
    FaFileAlt, FaFileSignature, FaGlobe,
    FaGlobeAmericas,
    FaGraduationCap,
    FaInfoCircle,
    FaKey, FaLeaf,
    FaLightbulb,
    FaList, FaListAlt,
    FaMapMarkerAlt,
    FaNewspaper,
    FaProjectDiagram,
    FaQuestionCircle, FaSitemap,
    FaTachometerAlt,
    FaUser, FaUserCog,
    FaUserLock,
    FaUsers,
    FaUserShield,
    FaUserTie
} from "react-icons/fa";
import styled, {css} from "styled-components";
import {Sidebar} from "react-pro-sidebar";
import {Link} from "react-router-dom";

const designTokens = {
    colors: {
        primary: 'rgba(255, 255, 255, 0.85)',
        accent: '#013e7d',
        accentDark: '#225080',
        accentLight: '#e3ecf7',
        text: 'rgba(0, 0, 0, 0.85)',
        textSecondary: 'rgba(60, 60, 67, 0.6)',
        background: '#f5f7fa',
        surface: 'rgba(255, 255, 255, 0.7)',
        border: 'rgba(60, 60, 67, 0.18)',
        divider: 'rgba(60, 60, 67, 0.12)',
        success: 'rgba(52, 199, 89, 0.9)',
        error: 'rgba(255, 59, 48, 0.9)',
        warning: 'rgba(255, 204, 0, 0.9)',
        info: '#b6cbe0',
    },
    shadows: {
        sm: '0 2px 8px rgba(0, 0, 0, 0.04)',
        md: '0 4px 12px rgba(0, 0, 0, 0.08)',
        lg: '0 8px 20px rgba(0, 0, 0, 0.12)', 
        xl: '0 20px 40px rgba(0, 0, 0, 0.16)',
        none: 'none',
    },
    transitions: {
        short: 'all 240ms cubic-bezier(0.33, 0.66, 0.66, 1)',
        medium: 'all 400ms cubic-bezier(0.33, 0.66, 0.66, 1)',
        spring: 'all 500ms cubic-bezier(0.25, 1, 0.5, 1)',
    },
    spacing: {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '3rem',
    },
    borderRadius: {
        sm: '0.375rem',
        md: '0.75rem',
        lg: '1.25rem',
        xl: '2rem',
        full: '9999px',
    },
    typography: {
        fontFamily: `-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "San Francisco", system-ui, "Helvetica Neue", Helvetica, sans-serif`,
        fontSizeBase: '1rem',
        fontSizeSm: '0.875rem',
        fontSizeLg: '1.25rem',
        fontWeightLight: 300,
        fontWeightNormal: 400,
        fontWeightMedium: 500,
        fontWeightSemibold: 600,
        fontWeightBold: 700,
    },
    glass: {
        blur: {
            sm: 'blur(4px)',
            md: 'blur(10px)',
            lg: 'blur(20px)',
        },
        opacity: {
            low: '0.6',
            medium: '0.8',
            high: '0.95',
        },
        border: '1px solid rgba(255, 255, 255, 0.18)',
    }
};
const componentMap = {
    'hazard': { icon: FaExclamationTriangle },
    'incident/report': { icon: FaFileAlt },
    'systemroles/access': { icon: FaUserShield },
    'permission/access': { icon: FaKey },
    'systemroles': { icon: FaUsers },
    'nonconformity': { icon: FaClipboardCheck },
    'improvement-opportunity': { icon: FaLightbulb },
    'complaint': { icon: FaComments },
    'manage': { icon: FaCogs },
    'user/access': { icon: FaUserLock },
    'gsp': { icon: FaEye },
    'audit': { icon: FaClipboardCheck },
    'tbt': { icon: FaChalkboardTeacher },
    'rhpw': { icon: FaCalendarAlt },
    'rpmw': { icon: FaCalendarAlt },
    'ldo': { icon: FaFileAlt },
    'list': { icon: FaList },
    'status': { icon: FaExclamationCircle },
    'country': { icon: FaGlobeAmericas },
    'state': { icon: FaGlobeAmericas },
    'city': { icon: FaCity },
    'business/group': { icon: FaBuilding },
    'business/unit': { icon: FaBuilding },
    'project': { icon: FaProjectDiagram },
    'project/client': { icon: FaUserTie },
    'site': { icon: FaMapMarkerAlt },
    'course': { icon: FaGraduationCap },
    'question': { icon: FaQuestionCircle },
    'news/my': { icon: FaNewspaper },
    'assign': { icon: FaBookOpen },
    'enrolled': { icon: FaGraduationCap },
    'inform/list': { icon: FaInfoCircle },
    'inform/status': { icon: FaInfoCircle },
    'user': { icon: FaUser },
    'dashboard': { icon: FaTachometerAlt },
    'cabinet': { icon: FaArchive },
    'permit': { icon: FaFileSignature },
    'templates': { icon: FaClipboard },
    'register': { icon: FaExclamationTriangle },
    'irc': { icon: FaFileAlt },
    'cfr': { icon: FaChartBar },
    'cir': { icon: FaUserTie },
    'is': { icon: FaClipboardCheck },
    'io': { icon: FaClipboardCheck },
    'pdr': { icon: FaExclamationTriangle },
    'csr': { icon: FaChartBar },
    'ier': { icon: FaLeaf },
    'iar': { icon: FaListAlt },
    'organization': { icon: FaSitemap },
    'dashboard/global': { icon: FaGlobe },
    'dashboard/country': { icon: FaGlobeAmericas },
    'user/review': { icon: FaCheckSquare },
    'user/issue': { icon: FaFileSignature },
    'inform/qc': { icon: FaClipboardCheck },
    'dashboard/my': { icon: FaUserCog },
    'ncr': { icon: FaExclamationCircle },
    'incr': { icon: FaExclamationTriangle }
};
const StyledSidebar = styled(Sidebar)`
    left: 0;
    bottom: 0;
    background: ${designTokens.colors.surface};
    border-right: 1px solid ${designTokens.colors.divider};
    height: calc(100vh - 70px) !important; /* Assuming 70px header height */
    margin-top: 70px; /* Align below header */
    margin-left: -25px;
    position: fixed; /* Keep sidebar fixed */
    transition: ${designTokens.transitions.medium};
    box-shadow: ${designTokens.shadows.md};
    z-index: 1000; /* Ensure sidebar is above main content */
    
    /* Enhanced hover effect when collapsed */
    ${props => props.collapsed ? css`
        &:hover {
            width: 280px !important; /* Explicit width on hover */
            min-width: 280px !important;
            box-shadow: ${designTokens.shadows.lg}; /* Stronger shadow on hover */
        }
    ` : ''}

    .ps-sidebar-root {
        border: none; /* Remove default border */
        height: 100%; /* Ensure root takes full height */
    }

    /* Menu Item Styling */
    .ps-menu-button {
        padding: ${designTokens.spacing.sm} ${designTokens.spacing.lg};
        font-size: ${designTokens.typography.fontSizeSm};
        color: ${designTokens.colors.textSecondary};
        font-weight: ${designTokens.typography.fontWeightMedium};
        border-radius: ${designTokens.borderRadius.md};
        margin: ${designTokens.spacing.xs} ${designTokens.spacing.sm}; /* Slightly more horizontal margin */
        transition: ${designTokens.transitions.short};
        position: relative; /* Needed for ::before pseudo-element */
        overflow: hidden; /* Clip hover effects */

        /* Subtle hover effect */
        &:hover {
            background: ${designTokens.colors.accentLight};
            color: ${designTokens.colors.accentDark};
            transform: translateX(3px); /* Subtle shift */
            /* Optional: Add a subtle border or glow */
            /* box-shadow: inset 0 0 0 1px ${designTokens.colors.accentLight}; */
        }
    }

    /* Submenu Content */
    .ps-submenu-content {
        background: ${designTokens.colors.surface}; /* Ensure consistent background */
        padding-left: ${designTokens.spacing.sm}; /* Indent submenu items slightly */
        padding-top: ${designTokens.spacing.sm};
        padding-bottom: ${designTokens.spacing.xs};
    }

    /* Icon Styling */
    .ps-menu-icon {
        color: ${designTokens.colors.textSecondary};
        margin-right: ${designTokens.spacing.sm};
        font-size: 1.1rem;
        transition: ${designTokens.transitions.medium};
        width: 20px; /* Ensure consistent icon spacing */
        text-align: center;
    }

    /* Active Menu Item Styling - Cover both className and active prop */
    .ps-active > .ps-menu-button, 
    .ps-menu-button[aria-current="page"],
    .ps-active > .ps-menu-button:hover {
        background: ${designTokens.colors.accentLight};
        color: ${designTokens.colors.accentDark};
        font-weight: ${designTokens.typography.fontWeightBold};
        box-shadow: ${designTokens.shadows.sm}; /* Subtle shadow for active item */
        
        /* More prominent active indicator */
        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%); /* Center vertically */
            height: 80%; /* Make indicator slightly taller */
            width: 4px; /* Slightly thicker */
            background-color: ${designTokens.colors.accent};
            border-radius: 0 ${designTokens.borderRadius.sm} ${designTokens.borderRadius.sm} 0; /* Rounded corners */
        }

        /* Active Icon Color */
        .ps-menu-icon {
            color: ${designTokens.colors.accent}; /* Use accent color for active icon */
        }
    }
    
    /* Submenu Arrow Icon */
    .ps-submenu-expand-icon {
        transition: ${designTokens.transitions.short};
    }
    
    /* Rotate arrow when submenu is open */
    .ps-submenu-root.ps-open > .ps-menu-button > .ps-submenu-expand-icon {
        transform: rotate(90deg);
    }
    
    /* Style for open submenu */
    .ps-submenu-root.ps-open > .ps-menu-button {
        background-color: rgba(13, 110, 253, 0.08);
        font-weight: ${designTokens.typography.fontWeightMedium};
    }

    /* Style for the 'Menu' Submenu for separation */
    .menu-separator {
      margin-top: ${designTokens.spacing.lg}; /* Add space above */
      position: relative;
      /* Optional: Add a subtle line */
       &::before {
         content: '';
         position: absolute;
         top: -${designTokens.spacing.md}; /* Position line above */
         left: ${designTokens.spacing.md};
         right: ${designTokens.spacing.md};
         height: 1px;
         background: ${designTokens.colors.divider};
       }
    }
`;
const MainContent = styled.main`
  flex: 1;
  margin-left: ${props => props.collapsed ? '10px' : '10px'};
  margin-top: 70px;
  padding: ${designTokens.spacing.sm};
  transition: all 0.5s cubic-bezier(0.25, 1, 0.5, 1);
  background: linear-gradient(to bottom right, rgba(245, 245, 247, 0.7), rgba(240, 244, 248, 0.7));
  backdrop-filter: ${designTokens.glass.blur.sm};
  -webkit-backdrop-filter: ${designTokens.glass.blur.sm};
  min-height: calc(100vh - 70px);
  overflow-x: hidden;
  position: relative;
  
  /* Page transition effects */
  .page-transition-enter {
    opacity: 0;
    transform: translateY(10px);
  }
  
  .page-transition-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 500ms cubic-bezier(0.25, 1, 0.5, 1), transform 500ms cubic-bezier(0.25, 1, 0.5, 1);
  }
  
  .page-transition-exit {
    opacity: 1;
    transform: translateY(0);
  }
  
  .page-transition-exit-active {
    opacity: 0;
    transform: translateY(-10px);
    transition: opacity 400ms cubic-bezier(0.25, 1, 0.5, 1), transform 400ms cubic-bezier(0.25, 1, 0.5, 1);
  }
  
  /* Animation for content loading */
  @keyframes contentFadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .animated-content {
    animation: contentFadeIn 0.5s cubic-bezier(0.25, 1, 0.5, 1);
  }
  
  /* Enhanced breadcrumbs */
    .breadcrumb-container {
        display: flex;
        align-items: center;
        background: rgba(255, 255, 255, 0.7);
        backdrop-filter: ${designTokens.glass.blur.md};
        -webkit-backdrop-filter: ${designTokens.glass.blur.md};
        padding: ${designTokens.spacing.sm} ${designTokens.spacing.lg};
        border-radius: ${designTokens.borderRadius.lg};
        margin-bottom: ${designTokens.spacing.lg};
        box-shadow: ${designTokens.shadows.sm};
        border-left: 4px solid ${designTokens.colors.accent};
        transition: ${designTokens.transitions.spring};
        border: ${designTokens.glass.border};

        &:hover {
            box-shadow: ${designTokens.shadows.md};
        }
    }

    /* Breadcrumb list itself */
    .breadcrumb {
        margin-bottom: 0;
        background: transparent;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: ${designTokens.spacing.xs};
        font-size: ${designTokens.typography.fontSizeSm};
        flex: 1;
    }

    /* Individual breadcrumb items */
    .breadcrumb-item {
        display: flex;
        align-items: center;
        position: relative;

        /* Styling for links within breadcrumbs */
        a {
            color: ${designTokens.colors.textSecondary};
            text-decoration: none;
            font-weight: ${designTokens.typography.fontWeightMedium};
            transition: ${designTokens.transitions.spring};
            padding: ${designTokens.spacing.xs} ${designTokens.spacing.sm};
            border-radius: ${designTokens.borderRadius.sm};
            display: flex;
            align-items: center;
            gap: ${designTokens.spacing.xs};

            &:hover {
                color: ${designTokens.colors.accent};
                background: rgba(0, 122, 255, 0.08);
                transform: translateX(2px);
            }
        }

        /* Styling for the active (last) breadcrumb item */
        &.active {
            color: ${designTokens.colors.text};
            font-weight: ${designTokens.typography.fontWeightSemibold};
            padding: ${designTokens.spacing.xs} ${designTokens.spacing.sm};
            border-radius: ${designTokens.borderRadius.sm};
        }

        /* Separator between items */
        & + .breadcrumb-item::before {
            color: ${designTokens.colors.textSecondary};
            content: "›";
            font-size: 1.1rem;
            line-height: 1;
            padding: 0 ${designTokens.spacing.sm};
            opacity: 0.6;
        }
    }

  /* Enhanced white card */
  .white-card {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: ${designTokens.glass.blur.md};
    -webkit-backdrop-filter: ${designTokens.glass.blur.md};
    border-radius: ${designTokens.borderRadius.lg};
    padding: ${designTokens.spacing.sm};
    box-shadow: ${designTokens.shadows.md};
    width: 100%;
    transition: ${designTokens.transitions.spring};
    border: ${designTokens.glass.border};
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: linear-gradient(to right, ${designTokens.colors.accent}, ${designTokens.colors.info});
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);
    }
    
    &:hover {
      box-shadow: ${designTokens.shadows.lg};
      transform: translateY(-5px) scale(1.01);
      
      &::before {
        transform: scaleX(1);
      }
    }
  }

  /* Enhanced table */
  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin: ${designTokens.spacing.md} 0;
    
    thead {
      background: rgba(0, 122, 255, 0.03);
    }
    
    th {
      font-weight: ${designTokens.typography.fontWeightSemibold};
      color: ${designTokens.colors.textSecondary};
      text-transform: uppercase;
      font-size: 0.75rem;
      letter-spacing: 0.05em;
      padding: ${designTokens.spacing.md} ${designTokens.spacing.lg};
      border-bottom: 2px solid ${designTokens.colors.divider};
      text-align: left;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: ${designTokens.colors.accent};
        transform: scaleX(0);
        transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1);
      }
      
      &:hover::after {
        transform: scaleX(0.8);
      }
    }
    
    td {
      padding: ${designTokens.spacing.md} ${designTokens.spacing.lg};
      border-bottom: 1px solid ${designTokens.colors.divider};
      color: ${designTokens.colors.text};
      transition: ${designTokens.transitions.spring};
    }
    
    tr:last-child td {
      border-bottom: none;
    }
    
    tbody tr {
      transition: ${designTokens.transitions.spring};
      
      &:hover {
        background-color: rgba(0, 122, 255, 0.05);
        transform: translateX(4px) scale(1.01);
        
        td {
          color: ${designTokens.colors.accent};
        }
      }
    }
  }
  
  /* Section headings */
  .section-heading {
    font-size: ${designTokens.typography.fontSizeLg};
    color: ${designTokens.colors.text};
    font-weight: ${designTokens.typography.fontWeightSemibold};
    margin-bottom: ${designTokens.spacing.lg};
    position: relative;
    padding-bottom: ${designTokens.spacing.sm};
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 3px;
      background: ${designTokens.colors.accent};
      border-radius: ${designTokens.borderRadius.full};
    }
  }
  
  /* Card layout within white-card */
  .card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: ${designTokens.spacing.lg};
    margin-top: ${designTokens.spacing.lg};
  }
  
  .info-card {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: ${designTokens.glass.blur.sm};
    -webkit-backdrop-filter: ${designTokens.glass.blur.sm};
    border-radius: ${designTokens.borderRadius.lg};
    padding: ${designTokens.spacing.lg};
    box-shadow: ${designTokens.shadows.sm};
    border: ${designTokens.glass.border};
    transition: ${designTokens.transitions.spring};
    position: relative;
    overflow: hidden;
    
    &:hover {
      transform: translateY(-4px) scale(1.02);
      box-shadow: ${designTokens.shadows.md};
      background: rgba(255, 255, 255, 0.8);
    }
    
    .card-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      background: rgba(0, 122, 255, 0.1);
      color: ${designTokens.colors.accent};
      border-radius: ${designTokens.borderRadius.full};
      margin-bottom: ${designTokens.spacing.md};
      font-size: 1.25rem;
      transition: ${designTokens.transitions.spring};
    }
    
    &:hover .card-icon {
      background: ${designTokens.colors.accent};
      color: rgba(255, 255, 255, 0.95);
      transform: scale(1.1) rotate(5deg);
    }
    
    .card-title {
      font-weight: ${designTokens.typography.fontWeightSemibold};
      font-size: 1.1rem;
      margin-bottom: ${designTokens.spacing.sm};
      color: ${designTokens.colors.text};
    }
    
    .card-value {
      font-size: 1.5rem;
      font-weight: ${designTokens.typography.fontWeightSemibold};
      color: ${designTokens.colors.accent};
    }
  }
  
  /* Responsive adjustments */
  @media (max-width: 1024px) {
    padding: ${designTokens.spacing.lg};
    
    .card-grid {
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    }
  }
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding: ${designTokens.spacing.md};
    
    .breadcrumb-container {
      padding: ${designTokens.spacing.sm};
    }
    
    .white-card {
      padding: ${designTokens.spacing.lg};
    }
    
    .card-grid {
      grid-template-columns: 1fr;
    }
    
    table {
      display: block;
      overflow-x: auto;
      
      th, td {
        min-width: 120px;
      }
    }
  }
`;
const BackButton = styled(Link)`
    display: flex;
    align-items: center;
    padding: ${designTokens.spacing.sm} ${designTokens.spacing.md};
    color: ${designTokens.colors.textSecondary};
    text-decoration: none;
    font-weight: ${designTokens.typography.fontWeightMedium};
    transition: ${designTokens.transitions.spring};
    border-radius: ${designTokens.borderRadius.md};
    margin: ${designTokens.spacing.sm} ${designTokens.spacing.sm} ${designTokens.spacing.md};
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: ${designTokens.glass.blur.sm};
    -webkit-backdrop-filter: ${designTokens.glass.blur.sm};
    border: ${designTokens.glass.border};
    
    &:hover {
        background: rgba(255, 255, 255, 0.8);
        color: ${designTokens.colors.accentDark};
        transform: translateX(-4px) scale(1.02);
        box-shadow: ${designTokens.shadows.sm};
    }
    
    svg {
        margin-right: ${designTokens.spacing.sm};
    }
`;


export {designTokens,BackButton,componentMap,StyledSidebar,MainContent}